import { styled, keyframes } from "styled-components";

const float = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-6px); }
`;

const haloPulse = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(37, 203, 168, 0.55), 0 8px 24px rgba(31, 180, 148, 0.3); }
  70% { box-shadow: 0 0 0 18px rgba(37, 203, 168, 0), 0 8px 24px rgba(31, 180, 148, 0.3); }
  100% { box-shadow: 0 0 0 0 rgba(37, 203, 168, 0), 0 8px 24px rgba(31, 180, 148, 0.3); }
`;

const blink = keyframes`
  0%, 90%, 100% { height: 14px; top: -28px; }
  95% { height: 2px; top: -16px; }
`;

const smileBreath = keyframes`
  0%, 100% { width: 38px; height: 16px; }
  50% { width: 42px; height: 19px; }
`;

const SmileyWrap = styled.div`
  position: relative;
  width: 80px;
  height: 80px;
  border-radius: 999px;
  background: linear-gradient(145deg, #25cba8, #17b28e);
  animation: ${float} 3s ease-in-out infinite, ${haloPulse} 1.6s ease-out infinite;
`;

const SmileyFace = styled.div`
  position: absolute;
  width: 38px;
  height: 16px;
  border: 4px solid #fff;
  border-top: 0;
  border-radius: 0 0 38px 38px;
  bottom: 22px;
  left: 50%;
  transform: translateX(-50%);
  animation: ${smileBreath} 3s ease-in-out infinite;

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: -28px;
    width: 10px;
    height: 14px;
    background: #fff;
    border-radius: 999px;
    animation: ${blink} 4s infinite;
  }
  &::before {
    left: 2px;
  }
  &::after {
    right: 2px;
  }
`;

export const SmileyMascot = () => (
  <SmileyWrap>
    <SmileyFace />
  </SmileyWrap>
);
